import React, { memo } from "react";

import { Company, EntityType, Person } from "@mapmycustomers/shared/types/entity";

import AddToRouteModal from "@app/component/AddToRouteModal";

interface Props {
  createdRecord: Company | Person;
  entityType?: EntityType.COMPANY | EntityType.PERSON;
  onHide: (added: boolean) => void;
}

const Routes = ({ createdRecord, entityType, onHide }: Props) => {
  return (
    <AddToRouteModal
      autoAssignOnCreate
      entities={
        entityType === EntityType.COMPANY ? [createdRecord as Company] : [createdRecord as Person]
      }
      onHide={onHide}
      visible
    />
  );
};

export default memo(Routes);
